module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/lib/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 117);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@h3-icons/basic");

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@h3/antd-vue/lib/modal/style"
var style_ = __webpack_require__(89);

// EXTERNAL MODULE: external "@h3/antd-vue/lib/modal"
var modal_ = __webpack_require__(7);
var modal_default = /*#__PURE__*/__webpack_require__.n(modal_);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/modal/double-check.vue?vue&type=template&id=c1264984&
var double_checkvue_type_template_id_c1264984_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-checkbox",
    { attrs: { checked: _vm.checked }, on: { change: _vm.onChange } },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
double_checkvue_type_template_id_c1264984_render._withStripped = true


// CONCATENATED MODULE: ./src/components/modal/double-check.vue?vue&type=template&id=c1264984&

// EXTERNAL MODULE: external "@h3/antd-vue/lib/checkbox/style"
var checkbox_style_ = __webpack_require__(90);

// EXTERNAL MODULE: external "@h3/antd-vue/lib/checkbox"
var checkbox_ = __webpack_require__(65);
var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./src/components/modal/double-check.vue?vue&type=script&lang=js&


/* harmony default export */ var double_checkvue_type_script_lang_js_ = ({
  name: 'DoubleCheckbox',
  components: {
    ACheckbox: checkbox_default.a
  },
  data: function data() {
    return {
      checked: false
    };
  },
  methods: {
    onChange: function onChange(evt) {
      this.checked = evt.target.checked;
      this.$emit('change', this.checked);
    }
  }
});
// CONCATENATED MODULE: ./src/components/modal/double-check.vue?vue&type=script&lang=js&
 /* harmony default export */ var modal_double_checkvue_type_script_lang_js_ = (double_checkvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./src/components/modal/double-check.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  modal_double_checkvue_type_script_lang_js_,
  double_checkvue_type_template_id_c1264984_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/modal/double-check.vue"
/* harmony default export */ var double_check = (component.exports);
// EXTERNAL MODULE: external "@h3/awesome-ui/dist/utils/vnode"
var vnode_ = __webpack_require__(3);

// EXTERNAL MODULE: external "@h3/awesome-ui/dist/utils/object"
var object_ = __webpack_require__(2);

// EXTERNAL MODULE: external "@h3-icons/basic"
var basic_ = __webpack_require__(1);

// CONCATENATED MODULE: ./src/components/modal/index.js



function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }





var H3Modal = {
  name: 'H3Modal',
  functional: true,
  inheritAttrs: false,
  model: modal_default.a.model,
  props: _extends({}, modal_default.a.props, {
    size: {
      type: String
    },
    width: {
      type: [Number, String]
    }
  }),
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        slots = _ref.slots;
    // TODO 临时方案，整体做了国际化之后，将此代码删除
    Object(object_["clearUndefined"])(props);
    var cacheProps = props;

    if (cacheProps) {
      cacheProps.okText = cacheProps.okText || '确定';
      cacheProps.cancelText = cacheProps.cancelText || '取消';
    } else {
      cacheProps = {
        okText: '确定',
        cancelText: '取消'
      };
    }

    if (!cacheProps.width) {
      var sizeMap = {
        sm: 480,
        md: 640,
        lg: 800,
        small: 480,
        medium: 640,
        large: 800
      };

      if (!cacheProps.size || !sizeMap[cacheProps.size]) {
        cacheProps.size = 'sm';
      }

      cacheProps.width = sizeMap[cacheProps.size];
    }

    if (!cacheProps.closeIcon) {
      cacheProps.closeIcon = function () {
        return h(basic_["IconCrossStroke"]);
      };
    }

    if (!cacheProps.cancelButtonProps) {
      cacheProps.cancelButtonProps = {
        props: {
          ghost: true
        },
        class: 'h3-modal__cancel-button-to-text'
      };
    }

    var slotContent = slots(); // 作用域插槽
    // 获取具名非作用域插槽

    var slotChildren = Object(vnode_["convertSlotChildren"])(slotContent, h, ['footer', 'title', 'okText', 'cancelText']);
    var children = [slotContent.default].concat(slotChildren);
    return h(modal_default.a, _extends({
      props: cacheProps,
      class: {
        'h3-modal': true
      }
    }, data), children);
  }
};

function h3ModalAdaptor(method, icon) {
  // TODO 临时方案，整体做了国际化之后，将此代码删除
  return function (opts) {
    var options = _extends({}, opts);

    var contentDef = options.content;
    options.centered = typeof options.centered === 'boolean' ? options.centered : true;
    options.width = 420;
    options.okText = options.okText || '确定';
    options.cancelText = options.cancelText || '取消';
    var wrapClass = 'h3-modal';
    options.class = options.class ? options.class + ' ' + wrapClass : wrapClass;
    options.cancelButtonProps = {
      props: {
        ghost: true
      },
      class: 'h3-modal__cancel-button-to-text'
    };

    options.icon = function (h) {
      return h(icon, {
        class: 'anticon'
      });
    };

    options.content = function (h) {
      var contentVNode = typeof contentDef === 'function' ? contentDef(h) : contentDef;
      return [h('div', {
        staticClass: 'h3-modal-confirm-scroll-content'
      }, [contentVNode])];
    };

    return method(options);
  };
} // 信息提示弹窗


H3Modal.info = h3ModalAdaptor(modal_default.a.info, basic_["IconInfoCirlceFill"]); // 成功提示弹窗

H3Modal.success = h3ModalAdaptor(modal_default.a.success, basic_["IconTickCircleFill"]); // 警告提示弹窗

H3Modal.warning = h3ModalAdaptor(modal_default.a.warning, basic_["IconExclamationCircleFill"]); // 警告提示弹窗

H3Modal.warn = H3Modal.warning; // 错误提示弹窗

H3Modal.error = h3ModalAdaptor(modal_default.a.error, basic_["IconCrossCircleFill"]); // 确认提示弹窗

H3Modal.confirm = h3ModalAdaptor(function (options) {
  if (options.doubleCheck) {
    var okButtonProps = {
      props: {
        disabled: true
      }
    };
    options.okButtonProps = okButtonProps;
    var contentDef = options.content;

    options.content = function (h) {
      var contentVNode = typeof contentDef === 'function' ? contentDef(h) : contentDef;
      return [h('div', {
        staticClass: 'h3-margin-bottom-lg h3-modal-confirm-scroll-content'
      }, [contentVNode]), h(double_check, {
        on: {
          change: function change(checked) {
            okButtonProps.props.disabled = !checked;
          }
        }
      }, options.checkContent)];
    };
  }

  options.centered = typeof options.centered === 'boolean' ? options.centered : true;

  options.icon = function (h) {
    return h(basic_["IconQuestionCircleFill"], {
      class: 'anticon'
    });
  };

  var modalController = modal_default.a.confirm(options);

  return modalController;
});

H3Modal.install = function (Vue) {
  Vue.component(H3Modal.name, H3Modal);
  Vue.prototype.$modal = H3Modal;
  Vue.prototype.$confirm = H3Modal.confirm;
  Vue.prototype.$info = H3Modal.info;
  Vue.prototype.$warn = H3Modal.warn;
  Vue.prototype.$warning = H3Modal.warning;
  Vue.prototype.$error = H3Modal.error;
  Vue.prototype.$success = H3Modal.success;
};

/* harmony default export */ var modal = __webpack_exports__["default"] = (H3Modal);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@h3/awesome-ui/dist/utils/object");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@h3/awesome-ui/dist/utils/vnode");

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

module.exports = require("@h3/antd-vue/lib/checkbox");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@h3/antd-vue/lib/modal");

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

module.exports = require("@h3/antd-vue/lib/modal/style");

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

module.exports = require("@h3/antd-vue/lib/checkbox/style");

/***/ })

/******/ });